<form
  class="bg-surface border-default flex w-full flex-col overflow-hidden rounded-lg border shadow-lg"
  aria-labelledby="set-time-title"
  (submit)="$event.preventDefault(); pin()">
  <div class="border-weak flex items-center gap-2 border-b px-3 py-2.5">
    <i class="text-accent-main" [class]="ICONS.clock"></i>
    <h2
      id="set-time-title"
      class="text-text-primary min-w-0 flex-1 truncate text-sm font-semibold">
      {{ keys().title | translate }}
      <span class="font-mono">{{ name() }}</span>
    </h2>
    <button
      type="button"
      class="text-text-tertiary hover:text-text-primary shrink-0 cursor-pointer rounded-xs transition-colors"
      [attr.aria-label]="'common.close' | translate"
      (click)="done.emit()">
      <i [class]="ICONS.x"></i>
    </button>
  </div>

  <div class="flex flex-col gap-1 p-3">
    <label for="set-time-start" class="form-label mb-0 text-xs">
      {{ keys().start | translate }}
    </label>
    <div class="flex items-center gap-3">
      <input
        #timeInput
        id="set-time-start"
        type="time"
        required
        class="form-input w-28 shrink-0 font-mono text-base tabular-nums"
        aria-describedby="set-time-zone set-time-note"
        [value]="time()"
        (input)="onTimeInput($event)" />
      <p id="set-time-zone" class="min-w-0 text-xs leading-snug">
        <span class="text-text-secondary block">{{ dayLabel() }}</span>
        <span class="text-text-tertiary block truncate">{{ request().siteTimeZone }}</span>
      </p>
    </div>
    <p id="set-time-note" class="form-help">
      {{ keys().note | translate }}
    </p>
  </div>

  <div class="border-weak flex items-center justify-between gap-2 border-t px-3 py-2.5">
    <button
      type="button"
      data-testid="set-time-release"
      class="btn text-danger hover:bg-danger-soft bg-transparent"
      (click)="release()">
      <i class="icon-slashed" [class]="ICONS.pushPin"></i>
      {{ keys().release | translate }}
    </button>
    <div class="flex gap-2">
      <button type="button" class="btn btn-cancel" (click)="done.emit()">
        {{ 'common.cancel' | translate }}
      </button>
      <button
        type="submit"
        data-testid="set-time-pin"
        class="btn btn-primary"
        [disabled]="!at()">
        <i [class]="ICONS.pushPinFill"></i>
        {{ keys().pin | translate }}
      </button>
    </div>
  </div>
</form>
